(function() {
  let isUpdating = false;
  let lastCartData = null;

  const originalFetch = window.fetch;
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  const TWD_UPSELL_MODE = 'mobile'; // 'mobile' | 'desktop' | 'all'

  const config = {
    domUpdateDelay: 1500,
    maxRetries: 5,
    retryDelay: 500
  };

  function isUpsellEnabled() {
    if (TWD_UPSELL_MODE === 'all') return true;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (TWD_UPSELL_MODE === 'mobile') return isMobile;
    if (TWD_UPSELL_MODE === 'desktop') return !isMobile;

    return false;
  }

  function getUpsellConfig() {
    const el = document.querySelector('.twd-upsell-config');

    if (!el) {
      console.log('[TWD] No upsell config found');
      return null;
    }

    const handles = (el.getAttribute('data-upsell-handles') || '').trim();
    const title = (el.getAttribute('data-upsell-title') || 'Pair with').trim();

    if (!handles) {
      console.log('[TWD] Upsell config found, but handles are empty');
      return null;
    }

    console.log('[TWD] Upsell config loaded', { handles, title });
    return { handles, title };
  }

  function appendUpsellToFormData(formData) {
    if (!isUpsellEnabled()) return formData;

    const upsell = getUpsellConfig();
    if (!upsell) return formData;

    formData.set('properties[_upsell_handles]', upsell.handles);
    formData.set('properties[_upsell_title]', upsell.title);

    console.log('[TWD] Injected upsell into FormData', {
      handles: formData.get('properties[_upsell_handles]'),
      title: formData.get('properties[_upsell_title]')
    });

    return formData;
  }

  function appendUpsellToJsonBody(body) {
    if (!isUpsellEnabled()) return body;

    const upsell = getUpsellConfig();
    if (!upsell) return body;

    if (body && typeof body === 'object') {
      body.properties = body.properties || {};
      body.properties._upsell_handles = upsell.handles;
      body.properties._upsell_title = upsell.title;
    }

    console.log('[TWD] Injected upsell into JSON body', body);
    return body;
  }

  function injectUpsellIntoUrlEncodedBody(body) {
    if (!isUpsellEnabled()) return body;

    const upsell = getUpsellConfig();
    if (!upsell || typeof body !== 'string') return body;

    const hasUpsellHandles =
      body.indexOf('properties%5B_upsell_handles%5D=') !== -1 ||
      body.indexOf('properties[_upsell_handles]=') !== -1;

    if (hasUpsellHandles) return body;

    const separator = body.length ? '&' : '';
    const injected =
      separator +
      'properties%5B_upsell_handles%5D=' + encodeURIComponent(upsell.handles) +
      '&properties%5B_upsell_title%5D=' + encodeURIComponent(upsell.title);

    const updatedBody = body + injected;

    console.log('[TWD] Injected upsell into URL-encoded body', {
      handles: upsell.handles,
      title: upsell.title
    });

    return updatedBody;
  }

  window.fetch = function(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';

    try {
      if (url.indexOf('/cart/add') !== -1 && init && init.body) {
        console.log('[TWD] Intercepting fetch add to cart', { url, body: init.body });

        if (init.body instanceof FormData) {
          appendUpsellToFormData(init.body);
        } else if (typeof init.body === 'string') {
          const contentType =
            (init.headers &&
              (init.headers['Content-Type'] || init.headers['content-type'])) || '';

          if (contentType.indexOf('application/json') !== -1) {
            const parsed = JSON.parse(init.body);
            init.body = JSON.stringify(appendUpsellToJsonBody(parsed));
          } else if (
            contentType.indexOf('application/x-www-form-urlencoded') !== -1 ||
            contentType === ''
          ) {
            init.body = injectUpsellIntoUrlEncodedBody(init.body);
          }
        }
      }
    } catch (error) {
      console.error('[TWD] Upsell injection via fetch failed', error);
    }

    return originalFetch.call(this, input, init);
  };

  XMLHttpRequest.prototype.open = function(method, url) {
    this._twdMethod = method;
    this._twdUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    try {
      const url = this._twdUrl || '';

      if (url.indexOf('/cart/add') !== -1) {
        console.log('[TWD] Intercepting XHR add to cart', { url, body });

        if (typeof body === 'string') {
          body = injectUpsellIntoUrlEncodedBody(body);
        } else if (body instanceof FormData) {
          appendUpsellToFormData(body);
        }
      }
    } catch (error) {
      console.error('[TWD] Upsell injection via XHR failed', error);
    }

    return originalXHRSend.call(this, body);
  };

  function updateFreeShippingWithRetry(retryCount = 0) {
    console.log(`Attempting to update free shipping (attempt ${retryCount + 1}/${config.maxRetries})`);

    const progressBarLabel = document.getElementById('rebuy-cart__progress-bar-meter-label');

    if (progressBarLabel) {
      const freeShippingLink = document.querySelector('a.wd-announcement-item-freeShip');

      if (!freeShippingLink) {
        console.log('Free shipping link not found');
        return;
      }

      const threshold = parseFloat(freeShippingLink.getAttribute('data-freeshipthreshold')) || 100;
      const labelText = progressBarLabel.textContent;

      if (labelText.includes("Congrats! You've unlocked FREE SHIPPING!")) {
        freeShippingLink.innerHTML = 'Congrats! You\'ve unlocked FREE SHIPPING!*';
        console.log('Free shipping message updated: Unlocked');
        return;
      }

      const priceMatch = labelText.match(/\$(\d+\.?\d*)/);

      if (priceMatch && priceMatch[1]) {
        const remainingAmount = parseFloat(priceMatch[1]);

        if (!isNaN(remainingAmount)) {
          if (remainingAmount === threshold) {
            freeShippingLink.innerHTML = `FREE SHIPPING on orders over <span>$${threshold.toFixed(2)}</span>*`;
            console.log('Free shipping message updated: Cart is empty');
          } else {
            freeShippingLink.innerHTML = `You're only $${remainingAmount.toFixed(2)} away from FREE SHIPPING! Keep shopping*`;
            console.log('Free shipping message updated: Progress - remaining: $' + remainingAmount.toFixed(2));
          }
        }
      } else {
        console.log('Could not extract price from progress bar text:', labelText);
      }
    } else {
      console.log('Progress bar element not found');

      if (retryCount < config.maxRetries - 1) {
        console.log(`Retrying in ${config.retryDelay}ms...`);
        setTimeout(() => {
          updateFreeShippingWithRetry(retryCount + 1);
        }, config.retryDelay);
      } else {
        console.error('Max retries reached. Progress bar element not found.');
      }
    }
  }

  function fetchCartData() {
    return originalFetch('/cart.js', {
      cache: 'reload',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    });
  }

  function onCartChange(triggerSource = 'unknown') {
    if (isUpdating) {
      console.log('Already updating, skipping...');
      return;
    }

    isUpdating = true;
    console.log('Cart changed! Triggered by:', triggerSource);

    setTimeout(() => {
      updateFreeShippingWithRetry();

      fetchCartData()
        .then(cart => {
          if (JSON.stringify(cart) !== JSON.stringify(lastCartData)) {
            console.log('Updated cart:', cart);
            lastCartData = cart;

            const cartCount = cart.item_count;
            document.querySelectorAll('.cart-count').forEach(el => {
              el.textContent = cartCount;
            });
          }

          if (isUpsellEnabled()) {
            document.dispatchEvent(
              new CustomEvent('twd:cart-updated', {
                detail: {
                  cart: cart,
                  source: triggerSource
                }
              })
            );
          }
        })
        .catch(error => console.error('Error fetching cart:', error))
        .finally(() => {
          setTimeout(() => {
            isUpdating = false;
          }, 500);
        });
    }, config.domUpdateDelay);
  }

  document.addEventListener('ajaxCart:added', () => onCartChange('ajaxAdd'));
  document.addEventListener('ajaxCart:updated', () => onCartChange('ajaxUpdate'));
  document.addEventListener('ajaxCart:removed', () => onCartChange('ajaxRemove'));

  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && form.action && form.action.includes('/cart')) {
      setTimeout(() => onCartChange('formSubmit'), 1000);
    }
  });

  document.addEventListener('click', function(e) {
    const button = e.target.closest(
      '[name="add"], [data-cart-add], .cart__remove, [data-cart-remove], .rebuy-cart__checkout-button, [data-rebuy-cart-remove], .rebuy-cart__flyout-item-remove, .rebuy-cart__flyout-item-quantity-widget-button'
    );

    if (button) {
      setTimeout(() => onCartChange('buttonClick'), 1000);
    }
  });

  let lastCartCount = 0;

  fetchCartData()
    .then(cart => {
      lastCartCount = cart.item_count;
      lastCartData = cart;
    })
    .catch(() => {});

  setInterval(function() {
    if (isUpdating) return;

    fetchCartData()
      .then(cart => {
        if (cart.item_count !== lastCartCount) {
          lastCartCount = cart.item_count;
          lastCartData = cart;
          onCartChange('polling');
        }
      })
      .catch(() => {});
  }, 3000);

  window.fetchCartData = fetchCartData;

  window.twdRefreshUpsells = function() {
    if (!isUpsellEnabled()) return;

    fetchCartData()
      .then(cart => {
        document.dispatchEvent(
          new CustomEvent('twd:cart-updated', {
            detail: {
              cart: cart,
              source: 'manual'
            }
          })
        );
      })
      .catch(error => console.error('Error refreshing upsells:', error));
  };

  setTimeout(() => {
    onCartChange('initial');
  }, 2000);

  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(() => onCartChange('rebuyEvent'), config.domUpdateDelay);
  });

  document.addEventListener('rebuy:cart.ready', () => {
    setTimeout(() => onCartChange('rebuyReady'), config.domUpdateDelay);
  });
})();

let lastScroll = 0;

window.addEventListener('scroll', function () {
  const currentScroll = window.scrollY;

  if (currentScroll > lastScroll && currentScroll > 200) {
    document.body.classList.add('scroll-down');
    document.body.classList.remove('active-scroll');
  }

  if (currentScroll < lastScroll) {
    document.body.classList.add('active-scroll');
    document.body.classList.remove('scroll-down');
  }

  if (currentScroll <= 0) {
    document.body.classList.remove('active-scroll');
    document.body.classList.remove('scroll-down');
  }

  lastScroll = currentScroll;
});